import "../scss/main.scss";

import $ from 'jquery';

import { Foundation } from 'foundation-sites/js/foundation.core';
import * as CoreUtils from 'foundation-sites/js/foundation.core.utils';
import { Box } from 'foundation-sites/js/foundation.util.box'
import { onImagesLoaded } from 'foundation-sites/js/foundation.util.imageLoader';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
import { Motion, Move } from 'foundation-sites/js/foundation.util.motion';
import { Nest } from 'foundation-sites/js/foundation.util.nest';
import { Timer } from 'foundation-sites/js/foundation.util.timer';
import { Touch } from 'foundation-sites/js/foundation.util.touch';
import { Triggers } from 'foundation-sites/js/foundation.util.triggers';
import { Abide } from 'foundation-sites/js/foundation.abide';
import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { AccordionMenu } from 'foundation-sites/js/foundation.accordionMenu';
import { Drilldown } from 'foundation-sites/js/foundation.drilldown';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
import { DropdownMenu } from 'foundation-sites/js/foundation.dropdownMenu';
import { Equalizer } from 'foundation-sites/js/foundation.equalizer';
import { Interchange } from 'foundation-sites/js/foundation.interchange';
import { Magellan } from 'foundation-sites/js/foundation.magellan';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
import { Orbit } from 'foundation-sites/js/foundation.orbit';
import { ResponsiveMenu } from 'foundation-sites/js/foundation.responsiveMenu';
import { ResponsiveToggle } from 'foundation-sites/js/foundation.responsiveToggle';
import { Reveal } from 'foundation-sites/js/foundation.reveal';
import { Slider } from 'foundation-sites/js/foundation.slider';
import { SmoothScroll } from 'foundation-sites/js/foundation.smoothScroll';
import { Sticky } from 'foundation-sites/js/foundation.sticky';
import { Tabs } from 'foundation-sites/js/foundation.tabs';
import { Toggler } from 'foundation-sites/js/foundation.toggler';
import { Tooltip } from 'foundation-sites/js/foundation.tooltip';
import { ResponsiveAccordionTabs } from 'foundation-sites/js/foundation.responsiveAccordionTabs';

Foundation.addToJquery($);

// Add Foundation Utils to Foundation global namespace for backwards
// compatibility.
Foundation.rtl = CoreUtils.rtl;
Foundation.GetYoDigits = CoreUtils.GetYoDigits;
Foundation.transitionend = CoreUtils.transitionend;
Foundation.RegExpEscape = CoreUtils.RegExpEscape;
Foundation.onLoad = CoreUtils.onLoad;

Foundation.Box = Box;
Foundation.onImagesLoaded = onImagesLoaded;
Foundation.Keyboard = Keyboard;
Foundation.MediaQuery = MediaQuery;
Foundation.Motion = Motion;
Foundation.Move = Move;
Foundation.Nest = Nest;
Foundation.Timer = Timer;

// Touch and Triggers previously were almost purely sede effect driven,
// so no need to add it to Foundation, just init them.
Touch.init($);
Triggers.init($, Foundation);
MediaQuery._init();

Foundation.plugin(Abide, 'Abide');
Foundation.plugin(Accordion, 'Accordion');
Foundation.plugin(AccordionMenu, 'AccordionMenu');
Foundation.plugin(Drilldown, 'Drilldown');
Foundation.plugin(Dropdown, 'Dropdown');
Foundation.plugin(DropdownMenu, 'DropdownMenu');
Foundation.plugin(Equalizer, 'Equalizer');
Foundation.plugin(Interchange, 'Interchange');
Foundation.plugin(Magellan, 'Magellan');
Foundation.plugin(OffCanvas, 'OffCanvas');
Foundation.plugin(Orbit, 'Orbit');
Foundation.plugin(ResponsiveMenu, 'ResponsiveMenu');
Foundation.plugin(ResponsiveToggle, 'ResponsiveToggle');
Foundation.plugin(Reveal, 'Reveal');
Foundation.plugin(Slider, 'Slider');
Foundation.plugin(SmoothScroll, 'SmoothScroll');
Foundation.plugin(Sticky, 'Sticky');
Foundation.plugin(Tabs, 'Tabs');
Foundation.plugin(Toggler, 'Toggler');
Foundation.plugin(Tooltip, 'Tooltip');
Foundation.plugin(ResponsiveAccordionTabs, 'ResponsiveAccordionTabs');

$(document).foundation();

// Hamburger toggle: toggles visual state and a body class `nav-open`
const hamburger = document.getElementById('hamburgerMenu');
if (hamburger) {
	hamburger.addEventListener('click', (e) => {
		const expanded = hamburger.getAttribute('aria-expanded') === 'true';
		hamburger.classList.toggle('is-active');
		hamburger.setAttribute('aria-expanded', String(!expanded));
		document.body.classList.toggle('nav-open');
	});
}

//Back to Top

$(document).ready(function(){ 
    $(window).scroll(function(){ 
        if ($(this).scrollTop() > 100) { 
            $('#top-button').fadeIn(); 
        } else { 
            $('#top-button').fadeOut(); 
        }
    }); 
    $('#top-button').click(function(){ 
        $("html, body").animate({ scrollTop: 0 }, 600); 
        return false; 
    }); 
});


/*
  Typing animation for multiple words.
  - words: array of strings
  - options:
    - typeSpeed: ms per character when typing
    - deleteSpeed: ms per character when deleting
    - pauseBetween: ms to wait after a word is fully typed before deleting
    - pauseAfterDelete: ms to wait after deleting (before typing next)
    - loop: boolean (true to loop)
    - shuffle: boolean (randomize order)
*/

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

async function typeWords(node, words, options = {}) {
  const {
    typeSpeed = 80,
    deleteSpeed = 40,
    pauseBetween = 1200,
    pauseAfterDelete = 200,
    loop = true,
    shuffle = false,
    cursorAtEnd = true // not used in this simple example but left for extensibility
  } = options;

  let wordList = Array.from(words);
  if (shuffle) {
    for (let i = wordList.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [wordList[i], wordList[j]] = [wordList[j], wordList[i]];
    }
  }

  const charContainer = node.querySelector('span');

  // keep going forever (if loop) or once through the list
  do {
    for (const word of wordList) {
      // Type each character
      for (let i = 0; i <= word.length; i++) {
        charContainer.textContent = word.slice(0, i);
        // small accessibility improvement: update ariaLive text
        node.setAttribute('aria-label', charContainer.textContent);
        await sleep(typeSpeed);
      }

      // Pause when full word typed
      await sleep(pauseBetween);

      // Delete characters
      for (let i = word.length; i >= 0; i--) {
        charContainer.textContent = word.slice(0, i);
        node.setAttribute('aria-label', charContainer.textContent);
        await sleep(deleteSpeed);
      }

      await sleep(pauseAfterDelete);
    }

    if (!loop) break;

    // if looping and shuffle enabled, re-shuffle each cycle
    if (loop && shuffle) {
      for (let i = wordList.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [wordList[i], wordList[j]] = [wordList[j], wordList[i]];
      }
    }

  } while (loop);
}

// ----- Example usage -----
const words = [
  "Healthcare",
  "Energy",
  "Communication",
  "Chemistry",
  "Agriculture"
];

const container = document.getElementById('typeText');

typeWords(container, words, {
  typeSpeed: 80,
  deleteSpeed: 35,
  pauseBetween: 1200,
  pauseAfterDelete: 150,
  loop: true,
  shuffle: false
}).catch(err => console.error(err));